const mapCharsToChange = {
    '“': '"',
    '”': '"',
    '„': '"',
    '‟': '"',
    '‘': '\'',
    '’': '\'',
    '‚': '\'',
    '‛': '\''
};

export class StringUtil
{
    public static replaceUnicodeQuotesIntoASCII(string:string)
    {
        return string.replace(/(“|”|„|‟|‘|’|‚|‛)/g, match => mapCharsToChange[match]);
    }

    public static capitalizeFirstLetter(string, lowercase:boolean = true)
    {
        const firstLetter = string.charAt(0).toUpperCase();
        const rest = string.slice(1);

        return `${firstLetter}${lowercase ? rest.toLowerCase() : rest}`;
    }

    public static camelCaseToLoDash(value:string):string
    {
        return value && value.replace(
            /([a-z])([A-Z])/g,
            '$1_$2'
        ).toLowerCase();
    }

    public static loDashToCamelCase(value:string):string
    {
        return value && value.replace(
            /([-_][a-z])/g,
            (group:string) => group[1].toUpperCase()
        );
    }
}
